import { useEffect, useRef } from "react";

export function useDatadogViewName(viewName?: string) {
    const lastViewNameRef = useRef<string | undefined>(undefined);

    useEffect(() => {
        if (!viewName) return;

        const setView = () => {
            window.DD_RUM?.onReady(() => {
                window.DD_RUM?.setViewName(viewName);
            });
        };

        if (viewName && viewName !== lastViewNameRef.current) {
            lastViewNameRef.current = viewName;
            setView();
        }
    }, [viewName]);
}
